import React, {useEffect, useState } from "react";
import "./VendorTermsConditions.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

function VendorTermsConditions({ name,user, company ,formSubmitted}) {
  const [formFilled, setFormFilled] = useState(false);
  const[searchParm]=useSearchParams ();
  const [formData,setFormData] = useState({
    Vendor_Id:1,
    CompanyName: "",
    DisplayName: "",
    Phone1: "",
    Phone2: "",
    VendorCategory:"",
    VendorGUID: "",
    CreatedBy:user,
    ModifiedBy: user
    });
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if(searchParm.get("vendorID")!=null){
    setFormData({...formData,VendorGUID:searchParm.get("vendorID")})
    }



  }, []);

  const handleSubmit = async (e) => {
    try {
      const response = await axios.post(
        // `${baseAPI}Admin/UpdateVendorFormSubmittedStatus`,
        `${baseAPI}Admin/AddSupplierDetail`,
        formData
      );
      toast.success("Thankyou for filling form!", {
        position: "top-right",
        autoClose: 2000, 
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setFormFilled(true);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid vendor_terms_main-div">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <h1 style={{ marginTop: "2px" }} className="heading_vendor">
            1. Introduction
          </h1>
          <p className="paragraph_vendon">
            These Terms and Conditions(hereinafter referred to as "Terms")
            govern the relationship between Carry My Pet, hence- forth referred
            to as {company} and {name}, henceforth referred to as {name}{" "}
            regarding the provision of pet relocation leads.
          </p>

          <h1 className="heading_vendor">2. Lead Submission</h1>

          <p className="paragraph_vendon">
            2.1. The Vendor agrees to provide pet relocation leads to the
            Company in accordance with the specifications outlined by the
            Company.
          </p>
          <p className="paragraph_vendon">
            2.2. Leads shall include accurate and complete information regarding
            pet owners seeking relocation services, includ- ing but not limited
            to: - Pet owner's name - Pet's species, breed, and age - Origin and
            destination locations - Contact information (email address, phone
            number) - Any special requirements or instructions required for the
            pet relocation process
          </p>

          <h1 className="heading_vendor">3. Lead Quality and Uniqueness</h1>
          <p className="paragraph_vendon">
            3.1. The Vendor warrants that all leads provided to the Company are
            - Genuine and represent legitimate inquiries from pet owners seeking
            relocation services. - Accurate and complete to the best of the
            Vendor's knowledge. - Exclusive and have not been previously
            provided to the Company or any other entity.
          </p>
          <p className="paragraph_vendon">
            3.2. The Vendor shall ensure that each lead submitted to the Company
            is unique and has not been duplicated or resold to any other party.
          </p>
          <p className="paragraph_vendon">
            If deemed agreeable same can be incorporated in Vendor
            Registration/Onboarding/CMP Owner Declaration Form:
          </p>

          <h1 className="heading_vendor">4. Operations and Executions</h1>
          <p className="paragraph_vendon">
            4.1. By agreeing to use CMP for Pet Transportation & other misc.
            services you (Vendor) is agreeing to accept all conditions of
            carriage without exception and agree that CMP decisions are final
            and are made in the best interest of the animal and its welfare.
          </p>
          <p className="paragraph_vendon">
            4.2. Vendor also agree that any act or omission from the airline,
            delays, cancellations, financial claims resulting from
            aforementioned instances/ restricted services are not in any way to
            be held against CMP or its associates.
          </p>
          <p className="paragraph_vendon">
            4.3. The utmost care and attention is given to the pets, they are
            handled with the understanding that CMP or its associates, kennels,
            agents and veterinarians are at no time to be held responsible for
            loss, death, illness, injury or accident due to any cause, either
            natural or accidental outside its own control.
          </p>
          <p className="paragraph_vendon">
            4.4. Vendor accept that by requesting CMP to provide transport for
            the pet that any animal can become stressed and chew or damage
            themselves on their crates.
          </p>
          <p className="paragraph_vendon">
            4.5. All services are quoted based on Monday-Friday 0900-1800 hrs
            service delivery, and any alteration to services may result in out
            of hours or weekend charges being applied to your booking.
          </p>
          <p className="paragraph_vendon">
            4.6. We reserve the right not to handle aggressive, reactive and
            fearful animals.
          </p>
          <p className="paragraph_vendon">
            4.7. All customers accept that if you require transport for a
            Brachycephalic/ Snub Nose breed, you accept that trans- port is
            arranged at the owners risk and may require a veterinary clearance
            dependent on the airlines requirements and or a disclaimer.
          </p>

          <h1 className="heading_vendor">
            5. Compliance with Laws and Regulations.
          </h1>
          <p className="paragraph_vendon">
            5.1. The Vendor agrees to comply with all applicable laws and
            regulations governing the provision of pet relocation services,
            including but not limited to animal welfare laws, transportation
            regulations, and data protection laws
          </p>

          <h1 className="heading_vendor">6. Confidentiality</h1>
          <p className="paragraph_vendon">
            6.1. Both parties agree to maintain the confidentiality of any
            sensitive information exchanged during the course of their business
            relationship, including but not limited to pet owner's personal
            information and proprietary business processes.
          </p>
          <p className="paragraph_vendon">
            6.2. The Vendor shall not disclose any confidential information
            obtained from the Company to third parties without prior written
            consent from the Company.
          </p>

          <h1 className="heading_vendor">7. Payment Terms</h1>
          <p className="paragraph_vendon">
            7.1. Payment for leads provided by the Vendor shall be made by the
            Company in accordance with the agreed-upon terms and pricing
            structure.
          </p>
          <p className="paragraph_vendon">
            7.2. Both parties agree that the referral amount for each relocation
            will as mentioned: Domestic – INR 1,000 Export: • Excess Baggage –
            INR 2,000 • Cargo – INR 5,000 Import: • Excess Baggage – INR 2,000 •
            Cargo – INR 4,000
          </p>
          <p className="paragraph_vendon">
            7.3. Payment will be transferred once the relocation is completed
            and the entire amount is received from the pet parent in a mutually
            agreed time period.
          </p>
          <p className="paragraph_vendon">
            7.4. The Company reserves the right to withhold payment for any
            leads that do not meet the quality standards or violate the terms
            outlined in this agreement.
          </p>

          <h1 className="heading_vendor">8. Term and Termination</h1>
          <p className="paragraph_vendon">
            8.1. This agreement shall commence on the date of acceptance by both
            parties and shall remain in effect until termi- nated by either
            party with [specify notice period] written notice.
          </p>
          <p className="paragraph_vendon">
            8.2. Either party may terminate this agreement immediately in the
            event of a material breach of any provision herein by the other
            party
          </p>

          <h1 className="heading_vendor">9. Governing Law</h1>
          <p className="paragraph_vendon">
            9.1. This agreement shall be governed by and construed in accordance
            with the jurisdiction of Delhi Court.
          </p>

          <h1 className="heading_vendor">10. Amendments</h1>
          <p className="paragraph_vendon">
            10.1. Any amendments or modifications to this agreement must be made
            in writing and signed by authorized repre- sentatives of both
            parties.
          </p>
          <h1 className="heading_vendor">11. Entire Agreement</h1>
          <p className="paragraph_vendon">
            11.1. These Terms and Conditions constitute the entire agreement
            between the Company and the Vendor regarding the subject matter
            herein and supersede all prior agreements and understandings,
            whether written or oral
          </p>
          <p className="paragraph_vendon">
 
            By accepting these Terms and Conditions, the Vendor acknowledges and
            agrees to abide by the terms outlined herein.
          </p>

          <br />
          <hr />
          <ToastContainer />
         {formSubmitted?
         null
         :
         
          <button
            style={{ position: "absolute", right: "12px" }}
            className="terms_condition_button"
            disabled={formFilled ? true : false}
            type="submit"
            onClick={handleSubmit}
          >
            Save
          </button>
         }
        </div>
      </div>
    </div>
  );
}

export default VendorTermsConditions;
